<template>
  <div class="nutheader">
    <nav class="navbar navbar-expand-md navbar-light bg-light">
      <router-link class="navbar-brand" to="/">{{brand}}</router-link>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item" v-if="user">
            <router-link class="nav-link" to="/avzyz">Avzyz</router-link>
          </li>
          <li class="nav-item" v-if="user">
            <router-link class="nav-link" to="/sezyz">Sezyz</router-link>
          </li>
          <li class="nav-item" v-if="user">
            <router-link class="nav-link" to="/suduzyz">Suduzyz</router-link>
          </li>
          <li class="nav-item" v-if="user">
            <router-link class="nav-link" to="/nrenvip">Nrenvip</router-link>
          </li>
          <li class="nav-item" v-if="user">
            <router-link class="nav-link" to="/newfhk">Newfhk</router-link>
          </li>
          <li class="nav-item" v-if="user">
            <router-link class="nav-link" to="/tnbt">Tnbt</router-link>
          </li>
          <li class="nav-item" v-if="user">
            <router-link class="nav-link" to="/sobt">Sobt</router-link>
          </li>
        </ul>
        <form class="form-inline my-1 my-xs-0" v-if="!user">
          <input
            class="form-control mr-xs-2"
            type="text"
            placeholder="source url"
            aria-label="urlInput"
            v-model="urlInput"
          />
          <input
            class="form-control mr-xs-2"
            type="text"
            placeholder="username"
            aria-label="username"
            v-model="username"
          />
          <input
            class="form-control mr-xs-2"
            type="password"
            placeholder="password"
            aria-label="password"
            v-model="password"
          />
          <button
            class="btn btn-outline-success my-2 my-xs-0"
            type="submit"
            @click.prevent="handleLogin"
          >登录</button>
        </form>
        <form class="form-inline my-1 my-xs-0" v-else>
          <h5>欢迎回来，{{user}}！</h5>
          <button
            class="btn btn-outline-success my-2 my-xs-0"
            type="submit"
            @click.prevent="handleLogout"
          >注销</button>
        </form>
      </div>
    </nav>
  </div>
</template>

<script>
import $ from "jquery/dist/jquery.min.js";
export default {
  name: "Nutheader",
  props: {
    brand: String,
    user: String,
    urlBaseInit: String
  },
  watch:{
    urlBaseInit:function(val){
      this.urlInput=val;
    }
  },
  data: function() {
    return {
      username: "",
      password: "",
      urlInput: ""
    };
  },
  computed: {
    userUrl: function() {
      return this.urlBase + "/users";
    },
    loginUrl: function() {
      return this.userUrl + "/login";
    },
    urlBase: function() {
      var urlBase = this.urlInput;
      if (this.urlInput && !this.urlInput.startsWith("http://")) {
        urlBase = "http://" + urlBase;
      }
      return urlBase;
    }
  },
  methods: {
    handleClickSource(e) {
      var source = e.target.text;
      this.$emit("changeSource", source);
    },
    handleLogin() {
      this.$emit("updateUrlBase", this.urlBase);
      if (this.username && this.password) {
        $.post(this.loginUrl, {
          username: this.username,
          password: this.password
        }).then(result => {
          if (result.success) {
            this.$emit("getToken", result.token);
          }
        });
      }
    },
    handleLogout() {
      this.$emit("dropToken");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
